/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React,{ useContext, useEffect, useRef, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { useFieldArray, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Images from "../../Api/Images";
import UploadFileAPI from "../../Api/uploadFIleApi";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import EmptyImage from "../../assets/image/EmptyImage.svg";
import Upload from "../../assets/image/Upload.svg";
import cross_for_viewcard from "../../assets/image/cross_for_viewcard.svg";
import parsePythonStyleJson from "./Function";

 const AppBanners = () => {
     const { appbannerList, accessToken } = useSelector(
    (state) => state.adminReducers
  );
    const { websocket } = useContext(WebSocketContext);
    const [loading ,setLoading] = useState(false)
  
  
    const {
      register,
      handleSubmit,
      formState: { errors },
      control,
      setValue,
      getValues,
    } = useForm({
      defaultValues: {
        documents:{ title: "", sub_title: "", image: {} },
      },
    });
  
    const { fields, append, remove,replace} = useFieldArray({
      control,
      name: "documents",
    });
    useEffect(() => {
    if (appbannerList?.list?.length > 0) {
      const UpdatedList = appbannerList.list.map((row) => {
        const privateKeyObj = parsePythonStyleJson(row?.document_image);
        return {
          title: row?.title || "",
          sub_title: row?.sub_title || "",
          image: privateKeyObj,
        };
      });
      replace(UpdatedList); 
    } else {
      replace([{ title: "", sub_title: "", image: {} }]);
    }
  }, [appbannerList?.list]);
  
  
    const addOption = () => {
      append({ title: "", sub_title: "", image: {} });
    };
    const removeOption = (index) => {
      if (fields.length > 1) {
        remove(index);
      }
    };

  const renderTrack = ({ style, ...props }) => {
    const trackStyle = {
      display: "none",
    };
    return <div style={{ ...style, ...trackStyle }} {...props} />;
  };

  function deleteBanner(id) {
    let param = {
      transmit: "single",
      url: "document_delete",
      request: {
        doc_id: id,
      },
    };
    wsSend_request(websocket, param);
    callDocumentList();
  }


    const UploadImage = async (e, index) => {
      const files = e.target.files[0];
      const formData = new FormData();
      formData.append("file", files, files.name);
      const fileresponse = await UploadFileAPI(accessToken, formData);
      if (fileresponse?.status === 200) {
        const currentDocuments = getValues("documents") || [];
  
        const updatedDocuments = [...currentDocuments];
        updatedDocuments[index] = {
          ...updatedDocuments[index],
          image: fileresponse,
        };
  
        setValue("documents", updatedDocuments);
      }
    };
  useEffect(() => {
    callDocumentList();
  }, [websocket]);

  const callDocumentList = () => {
    let param = {
      transmit: "single",
      url: "document_list",
      request: {
        limit: "20",
        page_no: 1,
        doc_type:"app_banner"
      },
    };
    wsSend_request(websocket, param);
  };
  const fileInputRef = useRef(null);

  const onSubmit = (data) => {
   const allImagesHaveId = data?.documents?.every(doc => doc?.image?.id);
   if (!allImagesHaveId) {
     toast.error("Please upload an image for all banners.");
     return;
   }
   setLoading(true)

    let param = {
      transmit: "single",
      url: "document_add",
      request: {
        document_image: "",
        title: "",
        sub_title: "",
        doc_type:"app_banner",
        documents:data?.documents
      },
    };
    wsSend_request(websocket, param);
     setTimeout(() => {
    callDocumentList();
    setLoading(false);
  }, 2000);
  };
  const handleClick = () => {
    fileInputRef.current.click();
  };
  const removeImage = (index) => {
      const currentDocuments = getValues("documents") || [];
      const updatedDocuments = [...currentDocuments];
      updatedDocuments[index].image = {};
      setValue("documents", updatedDocuments);

};
  return (
   <Scrollbars
        style={{ height: "calc(100vh - 185px)" }}
        renderView={(props) => <div {...props} className="view" />}
        renderTrackHorizontal={renderTrack}
        className="ScrollbarsSidebar"
      >
        <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mt-3 mb-2">
                <div className="col-12 col-md-12 col-sm-12 col-lg-12">
                  <div className="ms-3 label_class_name_for_input mb-3">
                    Upload Banner Image
                  </div>
                </div>
                {fields?.length > 0 ? (
                  <>
                    {fields?.map((banner, index) => {
                      return (
                          <React.Fragment key={index}>
                            <div className="d-flex gap-3 mt-3 w-100" style={{position:"relative"}}>
                              <div
                                className="file-upload ms-4 banner_upload_container_small"
                                onClick={handleClick}
                              >
                                <img src={Upload} alt="Upload" />
                                <h5
                                  className="text-banner-upload"
                                  style={{ position: "static", color: "#7C7C87" }}
                                >
                                  Upload Banner picture
                                </h5>
                                <span
                                  className="text-banner-upload"
                                  style={{ position: "static", color: "#234DCA" }}
                                >
                                  browse
                                </span>
                                <input
                                  type="file"
                                  onChange={(e) => UploadImage(e, index)}
                                  id={`file-${index}`}
                                  ref={fileInputRef}
                                  accept=".png, .jpg,"
                                  style={{ display: "none" }}
                                />
                                {errors?.documents?.[index]?.image && (
                                  <p className="input_error">
                                    {errors?.documents?.[index]?.image.message}
                                  </p>
                                )}
                              </div>
                              <div className="banner_image_box_small">
                                {banner?.image?.view_file_url && (
                                  <img
                                    src={cross_for_viewcard}
                                    alt="cross_for_viewcard"
                                    className="cross_for_viewcard banner_image_box_image"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                    onClick={() => removeImage(index)} 
                                  />
                                )}
                                {banner?.image?.view_file_url ? (
                                  <Images
                                    src={banner?.image?.id}
                                    height={"100%"}
                                    width={"100%"}
                                    alt="Banner"
                                  />
                                ) : (
                                  <div className="upload_box_empty">
                                    <img src={EmptyImage} alt="Upload Your" />
                                    <p className="upload_box_msg">
                                      Added Image Replace here
                                    </p>
                                  </div>
                                )}
                              </div>
                              <div
                                className="d-flex flex-col"
                                style={{ width: "540px", flexDirection: "column" }}
                              >
                                <div className="Height" style={{ width: "100%" }}>
                                  <div
                                    className="form-group"
                                    style={{ height: "85px" }}
                                  >
                                    <label
                                      htmlFor={"Title"}
                                      className="form-label label_class_name_for_input"
                                    >
                                      Title{" "}
                                      <span style={{ color: "#FF3939" }}>*</span>
                                    </label>
                                    <div className="d-flex">
                                      <input
                                        id={"Title"}
                                        type={"text"}
                                          defaultValue={banner?.title}
                                        {...register(`documents.${index}.title`, {
                                          required: "Answer is required",
                                        })}
                                        className="form-control input-common Poppins_400"
                                        placeholder={"Enter Title"}
                                      />
                                    </div>
                                    {errors?.documents?.[index]?.title && (
                                      <p className="input_error">
                                        {errors?.documents?.[index]?.title.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="Height" style={{ width: "100%" }}>
                                  <div
                                    className="form-group"
                                    style={{ height: "85px" }}>
                                    <label
                                      htmlFor={"Description"}
                                      className="form-label label_class_name_for_input"
                                    >
                                      Description{" "}
                                      <span style={{ color: "#FF3939" }}>*</span>
                                    </label>
                                    <div className="d-flex">
                                      <textarea
                                        id={"Description"}
                                        type={"text"}
                                          defaultValue={banner?.sub_title}
                                        {...register(`documents.${index}.sub_title`, {
                                          required: "Description is required",
                                        })}
                                        className="form-control input-common Poppins_400"
                                        placeholder={"Enter Description"}
                                        rows={5}
                                      />
                                    </div>
                                    {errors?.documents?.[index]?.sub_title && (
                                      <p className="input_error">
                                        {
                                          errors?.documents?.[index]?.sub_title
                                            .message
                                        }
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div
                                className="delete_button"
                                // onClick={() => deleteBanner(banner.id)}
                                onClick={() => removeOption(index)}
                              >
                                <span>Delete</span>
                              </div>
                            </div>
                            <div
                              style={{
                                borderBottom:
                                  index !== appbannerList?.list?.length - 1
                                    ? "1px solid #E4E4E7"
                                    : "none",
                                marginTop: "20px",
                                width: "98%",
                                marginLeft: "1%",
                              }}
                            />
                          </React.Fragment>
                      );
                    })}
                  </>
                ) : null}
                <div className="d-flex gap-4 mt-4 padding_left">
                  <div
                  className="banner_add_more_button"
                    onClick={addOption}
                  >
                    + Add More
                  </div>
                  <button
                    className={`btn btn-dark d-flex justify-content-center align-items-center banner_save_button`}
                    type="submit"
                    disabled={loading}
                  >
                    Save
                     {loading ? (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            ) :null}
                  </button>
                </div>
              </div>
            </form>
      </Scrollbars>
  )
}

export default AppBanners